import { Flex, Heading, Image, Text } from "@chakra-ui/react";
import React, { useContext, useEffect, useState } from "react";
import { Fade } from "react-awesome-reveal";
import { useNavigate, useParams } from "react-router-dom";
import YouTube from "react-youtube";
import Loading from "../../../components/Loading/Loading";
import { API } from "../../../shared/Api/Api";
import { Context } from "../../../shared/Context/Context";
import "./InfoDetail.scss";

const InfoDetail = () => {
  let { id } = useParams("id");
  const [infoDetail, setInfoDetail] = useState();
  const { tabletOrLess } = useContext(Context);
  const navigate = useNavigate();

  useEffect(() => {
    API.get("info/" + id).then((res) => {
      setInfoDetail(res.data);
    });
  });

  const youtube_parser = (url) => {
    var regExp =
      /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
    var match = url.match(regExp);
    return match && match[7].length === 11 ? match[7] : false;
  };

  return (
    <Flex justify="center" align="center" flexDir="column">
      {infoDetail ? (
        <>
          {!tabletOrLess && (
            <Image
              h="50px"
              m="20px"
              position="absolute"
              left="0"
              cursor="pointer"
              ml="0px"
              transition="margin-left, 1s"
              _hover={{ marginLeft: "-10px", transition: "margin-left, 1s" }}
              src="/assets/flechita.png"
              alt="volver"
              onClick={() => {
                navigate("/novedades");
              }}
            />
          )}
          <Flex
            justify="space-evenly"
            align="center"
            minH={tabletOrLess ? "100vh" : "87vh"}
            flexDir="column"
            w="70%"
          >
            <Fade triggerOnce>
              <Heading
                fontSize="40px"
                fontWeight="bolder"
                w="100%"
                mt={tabletOrLess && "70px"}
                mb={tabletOrLess && "30px"}
                textAlign="center"
              >
                {infoDetail.title}
              </Heading>
            </Fade>
            <YouTube
              className="videoDiv"
              iframeClassName="video"
              videoId={youtube_parser(infoDetail.video)}
            />
            <Fade triggerOnce>
              <Image
                mt="20px"
                w="100px"
                src="/assets/dancing.gif"
                alt="bailoteo gif gracioso"
              />
              <Text
                textAlign="center"
                fontSize="20px"
                fontWeight="bolder"
                backgroundColor="#ff6e6c"
                p="30px"
                color="#FFFFFF"
                borderRadius="10px"
              >
                {infoDetail.description}
              </Text>
            </Fade>
          </Flex>
        </>
      ) : (
        <Loading />
      )}
    </Flex>
  );
};

export default InfoDetail;
